import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface NavChildItem {
  label: string;
  href: string;
  external?: boolean;
}

export interface NavConfigItem {
  id: string;
  label: string;
  href: string;
  visible: boolean;
  group?: string;
  custom?: boolean;
  external?: boolean;
  children?: NavChildItem[];
}

export const DEFAULT_ABOUT_CHILDREN: NavChildItem[] = [
  { label: "About Us", href: "/about" },
  { label: "Editorial Team", href: "/about/editorial-team" },
  { label: "Editorial Guidelines", href: "/about/editorial-guidelines" },
  { label: "Announcements", href: "/about/announcements" },
  { label: "Contact", href: "/contact" },
];

export const DEFAULT_EXPLORE_CHILDREN: NavChildItem[] = [
  { label: "Prediction Markets", href: "/prediction-markets" },
  { label: "Market Movers", href: "/markets" },
  { label: "Community Predictions", href: "/scorecard" },
  { label: "Apps & Platforms", href: "/prediction-market-apps" },
  { label: "Legal Overview", href: "/legal" },
];

const DEFAULT_NAV: NavConfigItem[] = [
  { id: "news", label: "News", href: "/news", visible: true },
  { id: "summit", label: "Summit", href: "/summit", visible: true },
  { id: "learn", label: "Learn", href: "/learn", visible: true },
  { id: "explore", label: "Explore", href: "#", visible: true, group: "explore", children: DEFAULT_EXPLORE_CHILDREN },
  { id: "about", label: "About", href: "#", visible: true, group: "about", children: DEFAULT_ABOUT_CHILDREN },
];

export function useNavConfig() {
  return useQuery({
    queryKey: ["site-settings", "nav_config"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("site_settings")
        .select("value")
        .eq("key", "nav_config")
        .maybeSingle();
      if (error || !data) return DEFAULT_NAV;
      const items = (data.value as unknown as NavConfigItem[]) || DEFAULT_NAV;
      // Ensure built-in dropdowns have fallback children if not stored
      return items.map((item) => {
        if (item.id === "about" && !item.children) return { ...item, children: DEFAULT_ABOUT_CHILDREN };
        if (item.id === "explore" && !item.children) return { ...item, children: DEFAULT_EXPLORE_CHILDREN };
        return item;
      });
    },
    staleTime: 60_000,
  });
}
